import { useCallback, useEffect, useState } from "react";
import { api, extractList, getApiError } from "@/api/client";

export const useEarningsData = (limit, skip) => {
  const [state, setState] = useState({ items: [], total: 0, outstanding: 0, lifetime: 0, diamondShare: 0, payoutsLive: false, loading: true, error: "" });
  const load = useCallback(async () => {
    setState((current) => ({ ...current, loading: true, error: "" }));
    try {
      const { data } = await api.get("/admin/earnings", { params: { limit, skip } });
      setState({
        items: extractList(data, ["items"]),
        total: Number(data?.total_creators_with_earnings || 0),
        outstanding: Number(data?.total_diamonds_outstanding || 0),
        lifetime: Number(data?.total_lifetime_diamonds || 0),
        diamondShare: data?.diamond_share ?? 0,
        payoutsLive: Boolean(data?.payouts_live),
        loading: false,
        error: "",
      });
    } catch (error) { setState((current) => ({ ...current, loading: false, error: getApiError(error) })); }
  }, [limit, skip]);
  useEffect(() => { load(); }, [load]);
  return { ...state, reload: load };
};